import type { IStyleParam } from '@wix/tpa-settings';
import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

const defaultBodyMFont: NonNullable<
  IStyleParam<StyleParamType.Font>['getDefaultValue']
> = (params) =>
  wixFontParam('Body-M', {
    htmlTag: 'p',
    size: params.isMobile ? 14 : 16,
  })(params);

export type FulfillmentPickerStylesParams = {
  regularFont: StyleParamType.Font;
  regularTextColor: StyleParamType.Color;
  regularBackgroundColor: StyleParamType.Color;
  regularBorderColor: StyleParamType.Color;
  regularBorderWidth: StyleParamType.Number;
  regularCornerRadiusTopLeft: StyleParamType.Number;
  regularCornerRadiusTopRight: StyleParamType.Number;
  regularCornerRadiusBottomLeft: StyleParamType.Number;
  regularCornerRadiusBottomRight: StyleParamType.Number;
  regularCornerRadiusLinked: StyleParamType.Number;

  selectedFont: StyleParamType.Font;
  selectedTextColor: StyleParamType.Color;
  selectedBackgroundColor: StyleParamType.Color;
  selectedBorderColor: StyleParamType.Color;
  selectedBorderWidth: StyleParamType.Number;
  selectedCornerRadiusTopLeft: StyleParamType.Number;
  selectedCornerRadiusTopRight: StyleParamType.Number;
  selectedCornerRadiusBottomLeft: StyleParamType.Number;
  selectedCornerRadiusBottomRight: StyleParamType.Number;
  selectedCornerRadiusLinked: StyleParamType.Number;
};

export const fulfillmentPickerStylesParams =
  createStylesParams<FulfillmentPickerStylesParams>({
    regularFont: {
      type: StyleParamType.Font,
      getDefaultValue: defaultBodyMFont,
    },
    regularTextColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    regularBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-1', 1),
    },
    regularBorderColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    regularBorderWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
    regularCornerRadiusTopLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    regularCornerRadiusTopRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    regularCornerRadiusBottomLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    regularCornerRadiusBottomRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    regularCornerRadiusLinked: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },

    selectedFont: {
      type: StyleParamType.Font,
      getDefaultValue: defaultBodyMFont,
    },
    selectedTextColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8', 1),
    },
    selectedBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8', 0.1),
    },
    selectedBorderColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8', 1),
    },
    selectedBorderWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
    selectedCornerRadiusTopLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    selectedCornerRadiusTopRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    selectedCornerRadiusBottomLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    selectedCornerRadiusBottomRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    selectedCornerRadiusLinked: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
  });
